import { BaseEntity } from './Types';
import { nanoid } from 'nanoid';


export abstract class BaseModel<R, E> implements BaseEntity<R, E>{
    uuid: string = nanoid();

    abstract initialize(raw: R): void;

    abstract parse(): R;
}